import { DocumentEditorDialog } from "@/pages/dokumente/DocumentEditorDialog";
import { AuftragsbestaetigungFromAngebotDialog } from "@/pages/dokumente/AuftragsbestaetigungFromAngebotDialog";
import { useAuftragsbestaetigungFromAngebot } from "@/pages/dokumente/useAuftragsbestaetigungFromAngebot";
import { DocumentChainDeepLinkBridge } from "@/pages/dokumente/DocumentChainDeepLinkBridge";
import { useDocumentEditor } from "@/pages/dokumente/useDocumentEditor";
import { MODAL_STACK_GROUP_DOCUMENT_EDITOR, ModalStackGroup } from "@/lib/modalStack";

/**
 * Globale Dokument-Dialoge – innerhalb von TimesheetFlowProvider mounten
 * (NotesSection/Referenzen nutzen useTimesheetFlow).
 */
export function DocumentDialogsMount() {
  const { isOpen, docId, close, notifyDeleted, changeDocId } = useDocumentEditor();
  const {
    isOpen: abOpen,
    angebotId,
    close: closeAb,
  } = useAuftragsbestaetigungFromAngebot();

  return (
    <ModalStackGroup group={MODAL_STACK_GROUP_DOCUMENT_EDITOR}>
      <DocumentEditorDialog
        open={isOpen}
        docId={docId}
        onClose={close}
        onDeleted={notifyDeleted}
        onDocIdChange={changeDocId}
      />
      <AuftragsbestaetigungFromAngebotDialog open={abOpen} angebotId={angebotId} onClose={closeAb} />
      <DocumentChainDeepLinkBridge />
    </ModalStackGroup>
  );
}
